import React from "react";
import styles from "./CenteredSimpleLayout.module.css";

export const CenteredSimpleLayout: React.FC<React.PropsWithChildren> = ({
  children,
}) => {
  return (
    <div className={styles.centeredContainer}>
      <main className={styles.content}>
        <div className={styles.auto}>{children}</div>
      </main>
    </div>
  );
};
